export default "__VITE_ASSET__Cjd3PPnA__"